import { z } from "zod"
import { CustomerContactDetailsSchema } from "../customer"

export const JobCustomerSchema = CustomerContactDetailsSchema.extend({
  id: z.guid(),
  isClubMember: z.boolean(),
  jobId: z.guid(),
})
export type JobCustomer = z.infer<typeof JobCustomerSchema>
